import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

import './Scripts/loader.js';
// import './Scripts/aos.js';
import './Scripts/smoothScroll.js';
// import './Scripts/ticker.js';
// import './Scripts/tinySlider.js';
// import './Scripts/isotope.js';